import request from '@/utils/request'

// 获取路由
export const getRouters = () => {
  return request({
    url: '/system/menu/getRouters',
    method: 'get'
  })
}

// 获取网站首页菜单
export const getTopMenu = () => {
  return request({
    url: '/pc-api/index/getTopMenu',
    method: 'get'
  })
}